<template>
  <zj-layout-container
    v-loading="!IsNoLoading && loading"
    :element-loading-text="loadingText"
    class="eventinfocss bgcolor"
  >
    <zj-layout-main>
      <div class="zj-layout-main-content scrollable">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="16rem"
        >
          <el-collapse v-model="activeNames">
            <el-collapse-item name="EventInfo" v-if="EventInfo">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件信息：</span>
              </template>
              <el-form-item label="事件编号" style="display: inline-block">
                <el-input v-model="ruleForm.EventNo" disabled="true"></el-input>
              </el-form-item>
              <el-form-item
                label="事件名称"
                prop="EventName"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.EventName"
                  :disabled="EventInfoEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="事件级别"
                prop="EventLevel"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.EventLevel"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventLevelOptions"
                    :key="item.ItemKey"
                    :label="item.Extend1"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="事件类型"
                prop="EventType"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.EventType"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventTypeOptions"
                    :key="item.ItemKey"
                    :label="item.Extend1"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="接报方式"
                prop="EventWay"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.EventWay"
                  :disabled="EventInfoEdit"
                >
                  <el-option
                    v-for="item in EventWaypeOptions"
                    :key="item.ItemKey"
                    :label="item.Extend1"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="接报时间"
                prop="EventDate"
                style="display: inline-block"
                v-if="ruleForm.CreateTime"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.CreateTime"
                  disabled
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="事发时间"
                prop="EventDate"
                style="display: inline-block"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.EventDate"
                  :disabled="EventInfoEdit"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="事发地点"
                prop="EventLocation"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.EventLocation"
                  :disabled="EventInfoEdit"
                  style="width: 98rem"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="经度"
                prop="Longitude"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.Longitude"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="纬度"
                prop="Latitude"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.Latitude"
                  :disabled="true"
                  style="width: 34rem"
                ></el-input>
                <ZjLngLatSelect
                  :point_lat="ruleForm.Latitude"
                  :point_lng="ruleForm.Longitude"
                  @onGotLngLat="onGotLngLat"
                  style="margin-left: 1.5rem"
                ></ZjLngLatSelect>
              </el-form-item>
              <el-row>
                <el-form-item
                  label="事件描述"
                  prop="EventContent"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.EventContent"
                    :disabled="EventInfoEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-form-item
                label="总结说明："
                style="display: inline-block; margin-top: 2rem"
                v-if="EventSummeryShow"
              >
                <el-input
                  type="textarea"
                  :disabled="true"
                  v-model="ruleForm.SummaryDesc"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="归档描述："
                style="display: inline-block"
                v-if="EventSummeryShow"
              >
                <el-input
                  type="textarea"
                  :disabled="true"
                  v-model="ruleForm.FileDesc"
                ></el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="EventSource" v-if="EventSource">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件来源：</span>
              </template>

              <el-form-item
                label="上报人姓名"
                prop="ReporterName"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.ReporterName"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="上报单位"
                prop="ReportCompany"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.ReportCompany"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="联系方式"
                prop="ReporterPhone"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.ReporterPhone"
                  :disabled="EventSourceEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="上报时间"
                prop="ReportTime"
                style="display: inline-block"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="ruleForm.ReportTime"
                  :disabled="EventSourceEdit"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="EventAffect" v-if="EventAffect">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件影响：</span>
              </template>

              <el-form-item
                label="死亡人数"
                prop="DeadCount"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.DeadCount"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="受伤人数"
                prop="InjuredCount"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.InjuredCount"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="受困人数"
                prop="TrappedCount"
                style="display: inline-block"
              >
                <el-input
                  v-model.number="ruleForm.TrappedCount"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="影响半径"
                prop="InfluenceRadius"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.InfluenceRadius"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="经济损失"
                prop="EconomicLoss"
                style="display: inline-block"
              >
                <el-input
                  v-model="ruleForm.EconomicLoss"
                  :disabled="EventAffectEdit"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-form-item
                  label="已采取措施"
                  prop="TakeMeasures"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.TakeMeasures"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="当前救援情况"
                  prop="RescueSituation"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.RescueSituation"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="救援请求"
                  prop="RescueRequest"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.RescueRequest"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item
                  label="备注"
                  prop="Memo"
                  style="display: inline-block"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.Memo"
                    :disabled="EventAffectEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="EventConfirm" v-if="EventConfirm">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件核实：</span>
              </template>
              <el-row>
                <el-form-item
                  label="事件是否属实"
                  style="display: inline-block"
                >
                  <el-radio
                    v-model="ruleForm.IsTrue"
                    :label="1"
                    :disabled="EventConfirmEdit"
                    >是</el-radio
                  >
                  <el-radio
                    v-model="ruleForm.IsTrue"
                    :label="0"
                    :disabled="EventConfirmEdit"
                    >否</el-radio
                  >
                </el-form-item>
              </el-row>
              <el-form-item label="事件级别" style="display: inline-block">
                <el-select
                  v-model="ruleForm.ConfirmEventLevel"
                  :disabled="EventConfirmEdit"
                >
                  <el-option
                    v-for="item in EventLevelOptions"
                    :key="item.ItemKey"
                    :label="item.Extend1"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="事件类型"
                prop="EventType"
                style="display: inline-block"
              >
                <el-select
                  v-model="ruleForm.ConfirmEventType"
                  :disabled="EventConfirmEdit"
                >
                  <el-option
                    v-for="item in EventTypeOptions"
                    :key="item.ItemKey"
                    :label="item.Extend1"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-row>
                <el-form-item label="事发地点" style="display: inline-block">
                  <el-input
                    v-model="ruleForm.ConfirmEventLocation"
                    :disabled="EventConfirmEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="补充说明" style="display: inline-block">
                  <el-input
                    type="textarea"
                    v-model="ruleForm.SupplementMemo"
                    :disabled="EventConfirmEdit"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="EventReport" v-if="EventReport">
              <template slot="title">
                <i class="header-icon el-icon-arrow-down"></i>
                <span class="spantitle">事件上报：</span>
              </template>
              <el-tabs
                class="custom-tabs"
                v-model="editableTabsValue"
                @edit="handleTabsEdit"
                :editable="editable"
              >
                <el-tab-pane
                  :key="item.name"
                  v-for="item in editableTabs"
                  :label="item.title"
                  :name="item.name"
                >
                  <ReportEventTable
                    :ref="item.name"
                    :reportObj="item.reportObj"
                    :editable="!editable"
                  ></ReportEventTable>
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item>
          </el-collapse>
        </el-form>
        <slot name="default"></slot>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div v-if="!IsOnlyView">
        <div class="button-container">
          <el-button v-if="isTransferEmergency" @click="onBack()"
            >返回</el-button
          >
          <el-button v-if="IsAdd" type="primary" @click="submitForm(1)"
            >提交</el-button
          >

          <template v-if="!IsAdd">
            <el-button @click="onBack()">返回</el-button>
            <el-button type="primary" v-if="IsConfirm" @click="submitComfirm(2)"
              >核实</el-button
            >
            <el-button type="primary" v-if="IsReport" @click="submitReport(3)"
              >确认上报</el-button
            >
            <el-button type="primary" v-if="fasle" @click="startPlan()"
              >启动应急</el-button
            >
          </template>
        </div>
      </div>
    </zj-layout-footer>
    <el-dialog
      title="启动应急"
      :visible.sync="dialogOpts.dialogPlanTableVisible"
    >
      <EventPlan
        :viewData="dialogOpts.rowData"
        @cancel="dialogPlanCancel"
        @ok="dialogPlanOk"
        @search="search"
      ></EventPlan>
    </el-dialog>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import earlyMsgApi from "../../../../../../api/src/earlyMsg.js";
import ReportEventTable from "./ReportEventTable.vue";
import EventPlan from "./EventPlan.vue";
import {
  saveMsg,
  getMsgInfo,
  queryDevice,
} from "../../../../../../request/msgApi";
const utils = ZJApp.ZJUtils;
export default {
  props: {
    EventInfo: { type: Boolean, default: true }, //是否显示事件信息
    EventInfoEdit: { type: Boolean, default: false }, //是否能编辑事件信息
    EventSource: { type: Boolean, default: true }, //是否显示事件来源
    EventSourceEdit: { type: Boolean, default: false }, //是否能编辑事件来源
    EventAffect: { type: Boolean, default: true }, //是否显示事件影响
    EventAffectEdit: { type: Boolean, default: false }, //是否能编辑事件影响
    EventConfirm: { type: Boolean, default: true }, //是否显示事件确认
    EventConfirmEdit: { type: Boolean, default: false }, //是否能编辑事件确认
    EventReport: { type: Boolean, default: true }, //是否显示事件上报
    IsAdd: { type: Boolean, default: false },
    IsConfirm: { type: Boolean, default: false },
    IsReport: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    IsOnlyView: { type: Boolean, default: false },
    IsNoLoading: { type: Boolean, default: false }, //是否显示加载框
    EventSummeryShow: { type: Boolean, default: false }, //是否显示归档总结
    activeNames: {
      type: Object,
      default: function () {
        return [
          "EventInfo",
          "EventSource",
          "EventAffect",
          "EventConfirm",
          "EventReport",
        ];
      },
    },
    Status: { type: Number },
  },
  components: {
    ReportEventTable,
    EventPlan,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中",
      dialogOpts: {
        dialogPlanTableVisible: false,
        rowData: null,
      },
      EventTypeOptions: [],
      EventLevelOptions: [],
      EventWaypeOptions: [],

      ruleForm: {
        EventNo:
          "" +
          new Date().getFullYear() +
          (new Date().getMonth() + 1) +
          new Date().getDate() +
          new Date().getHours() +
          new Date().getMinutes() +
          new Date().getSeconds() +
          new Date().getMilliseconds(),
        EventName: "",
        EventLevel: null,
        EventType: null,
        EventId: "",
        EventWay: null,
        EventDate: new Date(),
        EventLocation: "",
        EventContent: "",
        ReporterName: "",
        ReportCompany: "",
        ReporterPhone: "",
        ReportTime: new Date(),
        DeadCount: 0,
        InjuredCount: 0,
        TrappedCount: 0,
        InfluenceRadius: "",
        EconomicLoss: "",
        TakeMeasures: "",
        RescueSituation: "",
        RescueRequest: "",
        Memo: "",
        OrgId: "",
        IsTrue: 1,
        Validity: 1,
        Status: 1,
        Longitude: 0,
        Latitude: 0,
      },
      rules: {
        EventName: [{ required: true, message: "请输入事件名称" }],
        EventLocation: [{ required: true, message: "请输入事发地点" }],
        ReporterName: [{ required: true, message: "请输入上报人姓名" }],
        ReporterPhone: [{ required: true, message: "请输入联系方式" }],
        DeadCount: [
          { required: true, message: "死亡人数不能为空" },
          { type: "number", message: "死亡人数必须为数字值" },
        ],
        InjuredCount: [
          { required: true, message: "受伤人数不能为空" },
          { type: "number", message: "受伤人数必须为数字值" },
        ],
        TrappedCount: [
          { required: true, message: "受困人数不能为空" },
          { type: "number", message: "受困人数必须为数字值" },
        ],
      },
      editableTabsValue: "report1",
      editableTabs: [],
      tabIndex: 1,
      alermInfo: {},
      isAlermEvent: false,
      msgInfo: {},
      AlerteLevelArr: [],
      AlertTypeArr: [],
      isTransferEmergency: false,
    };
  },
  methods: {
    init() {
      const eventId = this.$route.query.EventId;
      const AlarmId = this.$route.query.AlarmId;
      const MsgId = this.$route.query.MsgId;
      this.showLoading("加载中...");
      //判断来源是否是转应急事件，是的话在事件接报页添加返回
      if (AlarmId || MsgId) {
        this.isTransferEmergency = true;
      } else {
        this.isTransferEmergency = false;
      }
      utils
        .waitAll([
          this.config.getUValue("EmergencyService:FitEventType", ""),
          this.config.getUValue("EmergencyService:EmergencyEventLevel", ""),
          this.config.getUValue("EmergencyService:EmergencyEventWay", ""),

          eventId && eventId != ""
            ? new MyApis.EmergencyEventApi().GetItemById({ EventId: eventId })
            : Promise.resolve(undefined),
          this.config.getUValue("AlarmSubsystem:AlarmType", ""),
          AlarmId && AlarmId != ""
            ? new earlyMsgApi().GetItemById({ Id: AlarmId })
            : Promise.resolve(undefined),
          MsgId && MsgId != ""
            ? getMsgInfo({ id: MsgId })
            : Promise.resolve(undefined),
        ])
        .then((r) => {
          const eventtypeconf = r[0];
          this.EventTypeOptions = eventtypeconf.JValue;
          if (this.EventTypeOptions) {
            this.ruleForm.EventType = this.EventTypeOptions[0].ItemKey;
          }

          const eventlevelconf = r[1];
          this.EventLevelOptions = eventlevelconf.JValue;
          if (this.EventLevelOptions) {
            this.ruleForm.EventLevel = this.EventLevelOptions[0].ItemKey;
          }

          const eventwayconf = r[2];
          this.EventWaypeOptions = eventwayconf.JValue;
          if (this.EventWaypeOptions)
            this.ruleForm.EventWay = this.EventWaypeOptions[0].ItemKey;

          const eventInfoResult = r[3];
          if (
            eventInfoResult &&
            eventInfoResult.data &&
            eventInfoResult.data.Data
          ) {
            const eventInfo = eventInfoResult.data.Data;
            this.ruleForm = eventInfo;
            this.$emit("FinishTime", eventInfo.FinishTime);
            // this.ruleForm.IsTrue = 2;
            this.ruleForm.ConfirmEventLevel = this.ruleForm.ConfirmEventLevel =
              this.ruleForm.ConfirmEventLevel == null ||
              this.ruleForm.ConfirmEventLevel == ""
                ? this.ruleForm.EventLevel
                : this.ruleForm.ConfirmEventLevel;
            this.ruleForm.ConfirmEventType =
              this.ruleForm.ConfirmEventType == null ||
              this.ruleForm.ConfirmEventType == ""
                ? this.ruleForm.EventType
                : this.ruleForm.ConfirmEventType;
            //todo 获取上报信息
            this.GetEventReportList(eventId).then(() => {
              this.hideLoading();
            });
          } else {
            this.hideLoading();
          }

          this.AlertTypeArr = r[4].JValue;
          const warnInfoResult = r[5];
          if (
            warnInfoResult &&
            warnInfoResult.data &&
            warnInfoResult.data.Data
          ) {
            this.alermInfo = warnInfoResult.data.Data;
            if (this.isJson(this.alermInfo.Content.replace(/(<([^>]+)>)/ig, ""))) {
              const deviceInfo = JSON.parse(this.alermInfo.Content.replace(/(<([^>]+)>)/ig, ""));
              this.ruleForm.Longitude = deviceInfo.Longitude;
              this.ruleForm.Latitude =
                deviceInfo.Latitude || deviceInfo.Laitude;
            } else {
              this.ruleForm.Longitude = this.alermInfo.Longitude;
              this.ruleForm.Latitude = this.alermInfo.Latitude;
            }
            if (
              this.alermInfo.AlertType == 20 ||
              this.alermInfo.AlertType == 23
            ) {
              let content = this.alermInfo.Content.replace(/(<([^>]+)>)/ig, "");
              content = content.substring(
                content.indexOf("【") + 1,
                content.indexOf("】")
              );
              if (content) {
                this.findEquip(content);
              }
            }
            //事件名称-事件种类
            this.ruleForm.EventName = this.getType(this.alermInfo.AlertType);
            //接报方式-系统监测
            this.ruleForm.EventWay = "EmergencyEventWay-XT";
            //事件级别-紧急事件
            this.ruleForm.EventLevel = "EmergencyEventLevel-3";

            this.ruleForm.EventLocation = this.alermInfo.Location;
            if (this.ruleForm.Longitude && this.ruleForm.Latitude) {
              this.getAddress(this.ruleForm.Longitude, this.ruleForm.Latitude);
            }
            this.ruleForm.EventDate = this.alermInfo.BeginDate;
            this.ruleForm.EventContent = this.alermInfo.Content.replace(/(<([^>]+)>)/ig, "");

            //事件描述-【时间】【级别＋事件类型】【位置】【描述】
            const BeginDate = this.formatDate(this.alermInfo.BeginDate) == null ? this.formatDate(this.alermInfo.CreateTime) : this.formatDate(this.alermInfo.BeginDate);
            this.ruleForm.EventContent =
            BeginDate +
              "，" +
              this.getLevel(this.alermInfo.AlerteLevel) +
              this.ruleForm.EventName +
              "，" +
              (this.alermInfo.Location || "") +
              (this.alermInfo.Content.replace(/(<([^>]+)>)/ig, "") || "");
            //报送人-系统
            this.ruleForm.ReporterName = this.alermInfo.Contact || "系统";
            this.ruleForm.ReporterPhone = this.alermInfo.Phone;

            //报送时间-转应急的时间
            this.ruleForm.ReportTime = new Date();

            this.ruleForm.AlarmId = AlarmId;
            this.isAlermEvent = true;
          } else {
            this.hideLoading();
          }

          const msgInfoResult = r[6];
          if (MsgId && msgInfoResult && msgInfoResult.data) {
            this.msgInfo = msgInfoResult.data;
            //事件名称-事件种类
            this.ruleForm.EventName =
              this.msgInfo.categoryName || this.msgInfo.messageTypeName;
            //事件级别-紧急事件
            this.ruleForm.EventLevel = "EmergencyEventLevel-3";
            //接报方式-系统监测
            this.ruleForm.EventWay = "EmergencyEventWay-XT";
            //事发时间-预警的时间
            this.ruleForm.EventDate = this.msgInfo.dataTime;
            //事发地点-预警坐标
            this.ruleForm.Longitude = this.msgInfo.longitude;
            this.ruleForm.Latitude = this.msgInfo.latitude;
            if (this.ruleForm.Longitude && this.ruleForm.Latitude) {
              this.getAddress(this.ruleForm.Longitude, this.ruleForm.Latitude);
            }

            //事件描述-【时间】【级别＋事件类型】【位置】【描述】
            this.ruleForm.EventContent =
              this.msgInfo.dataTime +
              "，" +
              (this.msgInfo.levelName || "") +
              (this.msgInfo.categoryName || this.msgInfo.messageTypeName) +
              "，" +
              (this.msgInfo.address || "") +
              (this.msgInfo.content || "");
            console.log(this.msgInfo.dataTime +
              "，" +
              (this.msgInfo.levelName || "") +
              (this.msgInfo.categoryName || this.msgInfo.messageTypeName) +
              "，" +
              (this.msgInfo.address || "") +
              (this.msgInfo.content || ""))
            //报送人-系统
            this.ruleForm.ReporterName = "系统";
            //报送时间-转应急的时间
            this.ruleForm.ReportTime = new Date();
          }
        })
        .catch((e) => {
          console.log(e);
          this.hideLoading();
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //如果是环境监测的设备，按照名称获取经纬度
    findEquip(deviceName) {
      let params = {
        id: this.msgId,
        page: 1,
        size: 10,
        typeOneCode: "environmental_monitor",
        name: deviceName,
        model: "dustNoiseDevice",
      };
      const that = this;
      that.center = [];
      queryDevice(params).then((res) => {
        if (res && res.data.length > 0) {
          if (res.data[0].longitude && res.data[0].latitude) {
            this.ruleForm.Longitude = res.data[0].longitude;
            this.ruleForm.Latitude = res.data[0].latitude;
            this.getAddress(this.ruleForm.Longitude, this.ruleForm.Latitude);
          }
        }
      });
    },
    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getLevel: function (value) {
      let result = "";

      switch (value) {
        case 3:
          result = "蓝色";
          break;
        case 5:
          result = "黄色";
          break;
        case 7:
          result = "橙色";
          break;
        case 10:
          result = "红色";
          break;
      }
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    //根据经纬度反解析地址
    getAddress(Longitude, Latitude) {
      const that = this;
      // 创建地理编码实例, 并配置参数获取乡镇级数据
      var myGeo = new BMap.Geocoder({ extensions_town: true });
      // 根据坐标得到地址描述
      myGeo.getLocation(new BMap.Point(Longitude, Latitude), function (result) {
        if (result) {
          that.ruleForm.EventLocation = result.address;
        }
      });
    },
    showLoading(text) {
      this.loading = true;
      this.loadingText = text || "";
      this.$emit("showLoading", {
        text: text || "",
      });
    },
    hideLoading() {
      this.loading = false;
      this.$emit("hideLoading");
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    handleTabsEdit(targetName, action) {
      if (action === "add") {
        this.AddTable();
      }
      if (action === "remove") {
        this.RemoveTable(targetName);
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = parseFloat(obj.lat);
      this.ruleForm.Longitude = parseFloat(obj.lng);
      if (this.ruleForm.Longitude && this.ruleForm.Latitude) {
        this.getAddress(this.ruleForm.Longitude, this.ruleForm.Latitude);
      }
    },
    AddTable() {
      let newTabName = "report" + ++this.tabIndex;
      this.editableTabs.push({
        title: "上报信息",
        name: newTabName,
      });
      this.editableTabsValue = newTabName;
    },
    RemoveTable(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    GetEventReportList(EventId) {
      return new MyApis.EmergencyEventReportApi()
        .GetPageContentByConditions({
          EventId: EventId,
          PageSize: 1000,
          PageIndex: 1,
        })
        .then((r) => {
          r = r.data.Data;
          var data = r.PageContents;
          if (data && data.length > 0) {
            this.editableTabs = [];
            for (var i = 0; i < data.length; i++) {
              let newTabName = "report" + (i + 1);
              this.tabIndex = i + 1;
              var item = data[i];
              this.editableTabs.push({
                title: "上报信息",
                name: newTabName,
                reportObj: item,
              });
            }
            this.editableTabsValue = "report1";
          } else {
            this.editableTabs = [
              {
                title: "上报信息",
                name: "report1",
              },
            ];
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //事件上报
    submitReport(status) {
      // console.log(this.editableTabs); //todo
      var replist = []; //上报信息list
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.name][0];
        chil.GetValidate();
        var valiret = chil.valid;
        if (valiret == "fail") {
          this.editableTabsValue = item.name;
          return;
        }
        var obj = chil.ruleForm;
        if (obj) {
          obj.EventId = this.ruleForm.EventId;
          obj.OrgId = this.user.Departments[0].OrgId;
          replist.push(obj);
        }
      }
      if (replist.length > 0) {
        // 保存上报信息
        this.showLoading("保存中...");
        new MyApis.EmergencyEventReportApi()
          .AddItemList(replist)
          .then((r) => {
            if (r && r.data && r.data.Data) {
              this.submitForm(status); //保存
            } else {
              this.errmsg("保存失败，请联系管理员！");
            }
            this.logInfo.ActionName = "保存上报信息";
            this.logInfo.LogMessage = r
              ? "上报信息保存成功"
              : "上报信息保存失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急事件信息";
            this.addOperationLog();
            this.hideLoading();
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    submitComfirm(status) {
      if (this.ruleForm.IsTrue == 0) {
        status = 8;
      }
      if (status == 2) {
        this.ruleForm.CheckTime = new Date();
      }
      this.submitForm(status);
    },
    //事件接报
    submitForm(status) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.status = status;
          if (this.ruleForm.EventId == "") {
            this.ruleForm.OrgId = this.user.Departments[0].OrgId;
            if (!this.ruleForm.OrgId) {
              this.errmsg("部门Orgid,不能为空");
              return;
            }
            // this.user.OrgId == null ? "123" :  //todo
            //this.ruleForm.EventId = "123"; //todo
            let eventId = ZJApp.ZJUtils.uuid();
            this.ruleForm.EventId = eventId;
            this.showLoading("保存中...");
            new MyApis.EmergencyEventApi()
              .AddItem(this.ruleForm)
              .then((r) => {
                r = r.data.Data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！",
                });
                //this.saveMsg(this.ruleForm);
                if (this.isAlermEvent) {
                  this.updateAlermInfo(this.alermInfo);
                }
                // if (this.msgInfo) {
                //   this.updateMsg();
                // }
                this.hideLoading();
                this.logInfo.ActionName = "提交事件接报信息";
                this.logInfo.LogMessage = r
                  ? "事件接报信息提交成功"
                  : "事件接报信息提交失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急事件信息";
                this.addOperationLog();
                //跳转到核实详情
                this.$router.push({
                  path: "/plugin/emergency/ui/ConfirmEvent",
                  // name: 'mallList',
                  query: { EventId: eventId },
                });
              })
              .catch((e) => {
                console.log(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                this.hideLoading();
              });
          } else {
            this.showLoading("保存中...");
            new MyApis.EmergencyEventApi()
              .UpdateItem(this.ruleForm)
              .then((r) => {
                r = r.data.Data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！",
                });
                this.hideLoading();
                this.logInfo.ActionName = "提交事件核实信息";
                this.logInfo.LogMessage = r
                  ? "事件核实信息提交成功"
                  : "事件核实信息提交失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急事件信息";
                this.addOperationLog();
                //跳转到上报详情
                if (status == 2) {
                  let eventId = this.ruleForm.EventId;
                  this.$router.push({
                    path: "/plugin/emergency/ui/ReportEvent",
                    // name: 'mallList',
                    query: { EventId: eventId },
                  });
                } else if (status == 8) {
                  this.$router.go(-1);
                }
              })
              .catch((e) => {
                console.log(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                this.hideLoading();
              });
          }
        }
      });
    },
    //启动
    startPlan() {
      this.dialogOpts.rowData = this.ruleForm;
      this.dialogOpts.dialogPlanTableVisible = true;
    },
    dialogPlanOk() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    dialogPlanCancel() {
      this.dialogOpts.dialogPlanTableVisible = false;
    },
    saveMsg(ruleForm) {
      let level = "";
      if (ruleForm.EventLevel === "EmergencyEventLevel-3") {
        level = "warning_level_1";
      } else if (ruleForm.EventLevel === "EmergencyEventLevel-2") {
        level = "warning_level_2";
      } else {
        level = "warning_level_3";
      }
      let params = {
        creater: ZJApp.ZJUser.current.UserName,
        modifier: ZJApp.ZJUser.current.UserName,
        messageType: "event",
        dataTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        address: ruleForm.EventLocation,
        longitude: ruleForm.Longitude,
        latitude: ruleForm.Latitude,
        content: ruleForm.EventContent,
        category: ruleForm.EventType,
        level: level,
        type: "emergency_event", // 类型(0人工处理，1、转任务， 2、转应急)
        videos: "",
        audios: "",
        images: "",
        sourceId: ruleForm.EventId, //关联任务id，非必传
        sourceName: "应急事件",
      };
      saveMsg(params).then((res) => {
        console.log("人工处理预警结果");
        console.log(res);
      });
    },
    //更改消息
    updateMsg() {
      let extra = { remark: "已转为应急事件" };
      const param = {
        id: this.msgInfo.id,
        // extra: JSON.stringify(extra),
        status: "1",
      };
      saveMsg(param).then((res) => {});
    },
    //更改预警信息
    updateAlermInfo(alermInfo) {
      alermInfo.FinishDate = this.time(new Date());
      alermInfo.AcceptDate = this.time(new Date());
      // alermInfo.ProcessConclusion = "已转为应急事件";
      if (alermInfo.AlertType == "13") {
        alermInfo.ProcessStatus = 1;
      }

      alermInfo.ProcessWay = 1;
      alermInfo.ModifyTime = this.time(new Date());
      alermInfo.Modifier = ZJApp.ZJUser.current.UserName;
      alermInfo.EventType = "其他";
      new earlyMsgApi()
        .UpdateItem(alermInfo)
        .then((r) => {
          r = r.data.Data;

          this.logInfo.ActionName = "处理预警";
          this.logInfo.LogMessage = r ? "预警处理成功" : "预警处理失败";
          this.logInfo.ModuleName = "业务告警";
          this.logInfo.PageName = "预警信息-待处理详情";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    isJson(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    time(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
  },
  created: function () {
    this.init();
  },
};
</script>
<style>
.eventinfocss .el-input {
  width: 40rem;
}
.eventinfocss .el-textarea {
  width: 98rem;
}
.eventinfocss .el-date-editor {
  width: 40rem;
}
.eventinfocss .button-container {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.el-collapse .el-collapse-item .el-collapse-item__header {
  background-color: #0f3f6f;
  padding-left: 25px;
  border: none;
}
.el-collapse-item__content {
  padding-top: 25px;
  padding-bottom: 15px;
}
.spantitle {
  padding-left: 10px;
}
.el-collapse-item__wrap {
  will-change: height;
  background-color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  border: none;
}
.el-collapse {
  border: none;
}
.el-tabs__new-tab {
  margin-right: 20px;
  width: 40px;
  height: 20px;
}
</style>
